/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PromptTemplate } from '../models/PromptTemplate';
import type { PromptTemplateCreateRequest } from '../models/PromptTemplateCreateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PromptTemplatesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns PromptTemplate
     * @throws ApiError
     */
    public promptTemplateList(): CancelablePromise<Array<PromptTemplate>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/prompt-templates/',
        });
    }
    /**
     * @returns PromptTemplate
     * @throws ApiError
     */
    public promptTemplateCreate({
        requestBody,
    }: {
        requestBody: PromptTemplateCreateRequest,
    }): CancelablePromise<PromptTemplate> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/prompt-templates/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PromptTemplate
     * @throws ApiError
     */
    public promptTemplateUpdate({
        promptTemplateId,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this prompt template.
         */
        promptTemplateId: number,
        requestBody: PromptTemplateCreateRequest,
    }): CancelablePromise<PromptTemplate> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/prompt-templates/{prompt_template_id}/',
            path: {
                'prompt_template_id': promptTemplateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public promptTemplateDelete({
        promptTemplateId,
    }: {
        /**
         * A unique integer value identifying this prompt template.
         */
        promptTemplateId: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/prompt-templates/{prompt_template_id}/',
            path: {
                'prompt_template_id': promptTemplateId,
            },
        });
    }
}
